<style lang="stylus">
    .pagelike-empty-container
        min-height calc(100% - 64px)
        position relative
    .pagelike-container
        position relative
        margin-top 60px
    .pagelike-empty
        display flex
        justify-content center
        align-items center
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        .empty-box
            display flex
            justify-content center
            flex-wrap wrap
            width 250px
            .empty-svg
                width 178px
                height 84px
            .empty-text
                font-size 14px
                color #000
                text-align center
                margin-top 20px
                .tostore,a
                    color var(--themeColor)
                    cursor pointer
                    &:hover,&:link,&:active,&:visited
                        text-decoration underline

    .pagelike-page
        display flex
        justify-content space-around
        margin-top 15px
        color #626262 !important

        .el-pagination
            button
                background none !important

        .el-pager li
            background none
    .dark-theme__workbench
        .pagelike-empty
            .empty-box
                .empty-text
                    color #fff
                    .tostore
                        color #037fff
</style>
<template>
    <div :class="{ 'pagelike-container': works.length > 0 && isfixed, 'pagelike-empty-container': works.length <= 0 }">
        <div ref="con" class="page-waterfall" v-show="works.length != 0" :style="{ height: `${fitHeight}px` }">
            <waterfall ref="like" :workType="'like'" :works="works" />
        </div>

        <div class="pagelike-empty" v-if="!loading && works.length == 0">
            <div class="empty-box">
                <iconSymbol name="empty_like_works" />
                <p class="empty-text">{{ $t("nodata") }}</p>
                <p @click="toStore($event)" class="empty-text" v-html="$t('toStore')"></p>
            </div>
        </div>
    </div>
</template>
<script>
    import waterfall from "./mixins/waterfall.js";
    // import { Pagination } from "element-ui";
    export default {
        name: "PageLike",
        data() {
            return {
                works: [],
                waterfallType: "like",
                fitHeight: 0,
            };
        },
        mixins: [waterfall],
        components: {
            // Pagination,
        },
        props: {
            isfixed: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        computed: {
            isViewer() {
                return this.$store.state.userInfo.user_id != this.$store.state.userPage.viewerID;
            },
        },
        methods: {
            reloadPage() {
                this.works = this.$store.state.userPage.likeWorks;
                this.updateWaterfall({ works: this.works });
            },
            toStore(e) {
                if (e.target.tagName == "SPAN") {
                    this.$store.commit("toTplCenter", {
                        name: "showUserWorks",
                        data: false,
                    });
                }
            },
            resizeFit() {
                const topBar = 60;
                const menu = 64;
                const margin = 24;
                const pager = 24;
                let winH = window.innerHeight;
                this.fitHeight = winH - topBar - menu - margin - pager - margin;
            },
        },
        created() {
            this.$bus.$on("reloadLike", () => {
                this.reloadPage();
            });
            this.works = this.$store.state.userPage.likeWorks;

            this.resizeFit();
            window.addEventListener("resize", this.resizeFit);
        },
        beforeDestroy() {
            this.$bus.$off("reloadLike");
            window.removeEventListener("resize", this.resizeFit);
        },
    };
</script>
<i18n>
{
  "zh": {
    "nodata": "这里什么都没有哦,",
    "toStore": "快去<span class='tostore'>模板社区</span>看看吧"
  },
  "en": {
    "nodata": "It is empty"
  },
  "kr": {
    "nodata": "아직 아무 작업도 없네요~",
    "toStore": "<span class='tostore' > 템플릿 커뮤니티 </span>에 가보세요"
  },
  "tw": {
    "nodata": "這裡什麼都沒有哦"
  },
  "jp": {
    "nodata": "空です"
  },
  "id": {
    "nodata": "Kosong"
  }
}
</i18n>
